<template>
  <div style="height: auto;">
    <el-container>
      <el-header height="auto">
        <menu-tabs v-model="activeName" @handleTabClick="handleTabClick"></menu-tabs>
        <div style="height: auto;">
          <form-search v-model="formData" @search="onSearch" :activeName="activeName" ref="search"></form-search>
        </div>
      </el-header>
      <el-main>
        <keep-alive>
          <component v-if="showChild" :is="curComponent" :timeText="timeText" :data="formatedFormData" @handleTabsChange="handleTabsChange" ref="tabItem"></component>
        </keep-alive>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import menuTabs from './components/menuTabs/menuTabs'

import formSearch from './components/formSearch/formSearch'

import distribution from './children/distribution/distribution'
import orders from './children/orders/orders'
import nonStockOrders from './children/nonStockOrders/nonStockOrders'
import products from './children/products/products'
import packages from './children/packages/packages'

import moment from 'moment'
export default {
  components: { menuTabs, formSearch, distribution, orders, nonStockOrders, products, packages},
  data() {
    return {
      showChild:true,
      formData: {
        newTag: '',
        outStockOrder: '',
        orderDeliveries: '',
        deliveryCycles: [],
        platformIds: [],
        storeIds: [],
        commonTag: ''
      },
      activeName: 'distribution',
      timeText: {}
    }
  },
  computed: {
    curComponent() {
      return this.activeName
    },
    // 格式化的表单数据（时间YYYY-MM-DD hh:mm:ss）
    formatedFormData() {
      let tempForm = {};
      Object.keys(this.formData).forEach(key=>{
        tempForm[key] = this.formData[key];
        if (key === 'orderDeliveries') {
          tempForm[key] = this.formData[key] ? [Number(this.formData[key])] : [];
        }
        if((key === 'auditBeginTime' || key === 'productOnMarketBeginTime') && this.formData[key]) {
          tempForm[key] = moment(this.formData[key]).format('YYYY-MM-DD') + ' 00:00:00'
        }
        if((key === 'auditEndTime' || key === 'productOnMarketEndTime') && this.formData[key]) {
          tempForm[key] = moment(this.formData[key]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      });

      return tempForm
    }
  },
  methods: {
    // 监听事件-点击table内的数据，切换tab
    handleTabsChange(data) {
      this.activeName = data.tabName;
      this.formData = { ...data.formData }  // 初始化formDta
      this.onSearch()
    },
    // 监听事件-点击tabs按钮，切换tab
    handleTabClick(status) {
      // this.$refs['search'].clearFormData();  // 搜索条件清空
    },
    // 监听事件-点击概览数据，切换tab
    handleBusTabChange() {
      this.$bus.$on('changeTab', data => {
        this.activeName = data.tabName;
        // 缺货订单 true
        this.$set(this.formData, 'outStockOrder', data.status)
        this.onSearch();
      })
    },
    // 监听事件-点击table弹出层，切换tab
    handleBusTabChangeOntableDialog() {
      this.$bus.$on('changeTabOntableDialog', data => {
        this.activeName = data.tabName;
        this.formData = { ...data.formData }  // 初始化formDta
        this.onSearch();
      })
    },
    onSearch() {
      // this.showChild = false
      setTimeout(()=>{
        // this.showChild = true
        this.$nextTick(()=>{
          this.$refs['tabItem'].search();
        })
      })
    },
   async refreshTime() {
      let res = await this.$q.common.refreshTime({fragment: [51]})
      this.timeText = res.data
    }
  },
  mounted() {
    this.handleBusTabChange()
    this.handleBusTabChangeOntableDialog()
    this.refreshTime()
  }
}
</script>

<style lang="stylus" scoped>
  .el-container
    background #ffffff
    border-radius 4px
    overflow hidden
  >>> .el-main
    padding 0px 20px !important
</style>
